module.exports = __webpack_public_path__ + "img/merck.aed3f745.png";